import React from 'react';

import GroupTraitsForm from '../components/forms/GroupTraitsForm';
import ModeratorPage from '../components/layout/ModeratorPage';
import LocalLoadingIndicator from '../components/LocalLoadingIndicator';
import useCurrentUser from '../hooks/useCurrentUser';
import { JSONApi } from '../types';

import '../components/forms/CustomForm.scss';

type Props = {
  group: JSONApi.GroupResource;
};

const ManageGroupTraitsPage = ({ group }: Props) => {
  const currentUser = useCurrentUser();

  if (!currentUser) {
    return <LocalLoadingIndicator />;
  }

  return (
    <ModeratorPage group={group} h2Key="pages.manageGroup.traits.title">
      {() => (
        <div className="ion-padding-end ion-padding-start">
          <GroupTraitsForm group={group} />
        </div>
      )}
    </ModeratorPage>
  );
};

export default ManageGroupTraitsPage;
